import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: '!p-0',
    imageWrapper:
      'bg-blue-light aspect-square min-w-screen md:min-w-180 md:pl-4 lg:min-w-auto lg:p-0',
    image: 'object-cover',
    arrow: 'border-0',
    viewport: 'relative overflow-hidden',
    container: 'flex h-screen items-center lg:flex-col lg:gap-5',
    thumbs:
      'absolute bottom-15 z-10 flex gap-2 lg:top-1/2 lg:bottom-auto lg:left-20 lg:-translate-y-1/2 lg:transform lg:flex-col lg:items-center',
    thumb: 'aspect-square w-full object-cover',
    thumbsViewport: 'w-screen overflow-hidden lg:h-108 lg:w-auto',
    thumbsContainer: 'mx-3 flex gap-2 lg:h-108 lg:flex-col',
    thumbArrow: 'hidden h-6 border-0 p-0 text-black lg:block',
    video: 'h-full object-cover',
    closeButton: 'z-10'
  },
  variants: {
    zoom: {
      true: {
        thumbs: 'hidden lg:flex',
        image: 'overflow-visible',
        imageWrapper: 'h-screen cursor-zoom-out lg:cursor-move'
      },
      false: {
        viewport: '-mt-23 lg:mt-0',
        imageWrapper: 'cursor-zoom-in'
      }
    },
    hide: {
      true: {
        arrow: 'opacity-0',
        thumbArrow: 'opacity-0'
      }
    }
  }
});
